import logo from './assets/images/logo.png';
export const Logo = logo;
export const title = 'Appsy';
export const LInkdinURL = "https://www.linkedin.com/in/devparwinderofficial";
export const InstaURL = "https://www.instagram.com/garry__sahota__official";
export const PhoneNumber = "7009422802";
export const EmailAddress = "GarrySahotaOfficial@gmail.com";
export const HireLink = "https://calendly.com/garrysahotaofficial/30min";